<template>
	<div :class="['list-box', { height: height }]">
		<div v-if="data && data.length > 0">
			<div
				v-for="(item, index) in data"
				:key="index"
				@click="checkone(item, index)"
				:class="['chat-box', { isGarbage: item.garbageFlag }, { bgcolor: index == check }]"
				:id="index"
			>
				<div style="position: relative" class="img-box">
					<div class="img" :style="item.dataType == 2 ? '' : 'background: #d3d6db'">
						<div v-if="item.dataType == 2" class="xiansuo contactProfilePicture">
							{{ checkChinese(item) }}
						</div>
						<img v-else :src="item.headPath || require('@/assets/default.png')" class="img" />
						<symbolIcon
							:name="item.dataType == 2 ? 'whatsapp' : 'messenger'"
							class="messenger-icon"
						></symbolIcon>
					</div>
					<!-- <el-tooltip
						effect="dark"
						:content="'跟进人：' + item.followupName"
						placement="right-start"
					>
						<img
							style="border: 2px #fff solid"
							:src="item.followupHeadPath || require('@/assets/defaultAvatar.png')"
							class="img1"
							v-if="item.followupName"
						/>
					</el-tooltip> -->
				</div>
				<div class="info">
					<div style="position: relative">
						<div style="display: flex">
							<span class="name">
								<span class="title">{{ item.title }}</span>
								<span>
									<el-tooltip effect="dark" content="客户" placement="right-start">
										<ig-icon
											name="kehulianxiren"
											style="color: #0f9f39; font-size: 18px"
											v-if="item.type == 2"
										></ig-icon>
									</el-tooltip>
									<el-tooltip effect="dark" content="线索" placement="right-start">
										<ig-icon
											name="xiansuolianxiren"
											style="color: #3da1ff; font-size: 18px"
											v-if="item.type == 1"
										></ig-icon>
									</el-tooltip>
								</span>
							</span>

							<span class="time">{{ item.latelyTimeStr }}</span>
						</div>
					</div>
					<div style="padding-top: 6px; display: flex">
						<div class="msg">
							<!-- && item.type != 0 -->
							<span class="nofollow" v-if="!item.followupName">[待分配]</span>
							<span class="nofollow" v-if="item.followupName && !isMytype"
								>[{{ item.followupName }}]</span
							>
							<span v-html="item.msgContent"></span>
						</div>
						<div style="width: 45px">
							<span class="msgNum" v-if="item.msgNum">{{ item.msgNum }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="nomsg">
			<ig-icon name="nomsg" style="font-size: 28px; color: #999999"></ig-icon>
			<div>暂无消息</div>
		</div>
	</div>
</template>
<script>
import symbolIcon from '@/components/iglobalwin/ig-icon/symbolIcon.vue';
export default {
	components: {
		symbolIcon,
	},
	props: {
		data: {
			type: Array,
		},
		height: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
		},
		isMytype: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
			check: -1,
		};
	},

	watch: {
		id: {
			handler(val) {
				if (val && val.length) {
					let index = this.data.findIndex(ele => {
						return ele.id == val;
					});
					this.check = index;
				}
			},
			immediate: true,
		},
		data: {
			handler() {
				this.check = -1;
				this.checkone(undefined, -1);
				if (this.data && this.data.length > 0) {
					let index = this.data.findIndex(ele => {
						return ele.id == this.id;
					});
					this.check = index;
				}
			},
			immediate: true,
		},
	},
	methods: {
		checkone(item, index) {
			if (item) {
				if (item.msgNum) {
					item.msgNum = 0;
					this.$store.dispatch('getchatUnread');
					this.$store.dispatch('getNum');
				}

				//未读消息跳转
				if (this.height) {
					if (this.getPermission('liveChatNew')) {
						let name = this.getPermission('allChat') ? 'allChat' : 'chat';
						this.$router.push({
							name: name,
							query: {
								type: item.type,
								id: item.id,
								tableId: item.tableId,
								logo: item.headPath,
								messengerUserId: item.messengerUserId,
								fbName: item.title,
								assignmentFlag: item.followupId ? 1 : 0,
								dataType: item.dataType,
							},
						});
					} else {
						this.$router.push({
							name: 'liveChat',
							query: {
								type: item.type,
								id: item.id,
								tableId: item.tableId,
								logo: item.headPath,
								messengerUserId: item.messengerUserId,
								fbName: item.title,
							},
						});
					}
				}
				this.$emit('checkone', item);
			}
			this.check = index;
		},
		checkChinese(item) {
			let val = item.title;
			var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
			if (reg.test(val)) {
				return val.substring(0, 1);
			} else {
				if (val) {
					val = val.toLowerCase();
					let name = val.charAt(0).toUpperCase() + val.slice(1);
					return name.substring(0, 2);
				}
			}
			return '无';
		},
	},
};
</script>
<style lang="scss" scoped>
.contactProfilePicture {
	width: 30px;
	height: 30px;
	border-radius: 50%;
	text-align: center;
	line-height: 30px;
	font-size: 14px;
}
.xiansuo {
	background: rgba(61, 161, 255, 0.16);
	border: 1px solid #3da1ff;
	color: #2691e9;
}
.list-box {
}
.chat-box {
	width: 100%;
	height: 65px;
	border-bottom: 1px #e8e8e8 solid;
	display: flex;
	padding: 10px 10px 0px 10px;
	cursor: default;
}

// 垃圾询盘
.isGarbage {
	position: relative;
	&::after {
		content: '疑';
		position: absolute;
		top: 10px;
		right: 35px;
		transform: rotate(40deg);
		width: 45px;
		height: 45px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 20px;
		opacity: 0.5;
		pointer-events: none; /* 防止水印干扰交互 */
		z-index: 0;
		border: 2px solid rgba(255, 197, 61);
		color: rgba(255, 197, 61);
	}
}

.bgcolor {
	background: #eeeeee;
}
.chat-box:hover {
	background: #f9f9f9;
}
.img-box {
	.img {
		width: 30px;
		height: 30px;
		// border: 1px #f9f9f9 solid;
		border-radius: 15px;
		object-fit: contain;
		display: inline-block;
		vertical-align: top;
		margin-right: 15px;
		position: relative;
	}
	.messenger-icon {
		font-size: 18px;
		position: absolute;
		bottom: 0px;
		right: -7px;
	}
	.img1 {
		position: absolute;
		width: 20px;
		height: 20px;
		border-radius: 10px;
		object-fit: contain;
		display: inline-block;
		vertical-align: top;
		top: 10px;
		left: 16px;
	}
}

.info {
	width: 200px !important;
	.name {
		display: flex;
		flex: 1;
		font-weight: 500;
		color: #333333;
		font-size: 14px;
		.title {
			min-width: 50px;
			max-width: 90px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			margin-right: 8px;
		}
	}
	.tag {
		display: inline-block;
		padding: 1px 6px;
		margin-left: 10px;
		background: #edf5fe;
		border-radius: 2px;
		border: 1px solid #ddecfe;
		color: #3da1ff;
		font-size: 12px;
	}
	.time {
		font-weight: 400;
		color: #666666;
		font-size: 12px;
		margin-right: 15px;
	}
	.msg {
		width: 180px;
		height: 30px;
		font-weight: 400;
		color: #666666;
		font-size: 12px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		.nofollow {
			color: #3da1ff;
			padding-right: 5px;
		}
	}
	.msgNum {
		// min-width: 20px;
		// max-width: 25px;
		height: 15px;
		// margin-right: -35px;
		padding: 0px 5px;
		background: #f5222d;
		border-radius: 10px;
		color: #fff;
		text-align: center;
		line-height: 15px;
		font-size: 10px;

		// float: right;
	}
}
.height {
	max-height: 380px;
	overflow-x: hidden;
	overflow-y: auto;
	// 	改变滚动条样式
	&::-webkit-scrollbar {
		width: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #d8d8d8;
		border-radius: 6px;
	}

	&::-webkit-scrollbar-track {
		background-color: #fff;
		border-radius: 2px;
	}

	.btn-panel {
		width: 97%;
		padding: 5px;
		background-color: white;
		position: absolute;
		bottom: 20px;
		right: 20px;
	}
}
.nomsg {
	padding: 20px;
	text-align: center;
	color: #999999;
}
</style>
